import { v4 as uuid } from "uuid";
/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "EFkyxzJtiv4",
    title: "Stoicism: Become Undefeatable",
    category:"Stoicism",
    thumbnail:"https://img.youtube.com/vi/EFkyxzJtiv4/sddefault.jpg",
    description:
      "Stoicism helps us steer through past and present storms into calmer and more peaceful waters. And if our ship sinks and we all drown, we can take peace in the fact that we lived a good life, albeit not as long as we had hoped. Because remember, everything has an end.",
    creator: "Aperture",
  },
  {
    _id: "2bguEiUgDA4",
    title: "BE UNSHAKEABLE - The Ultimate Stoic Quotes",
    creator: "RedFrost",
    category:"Stoicism",
    thumbnail:"https://img.youtube.com/vi/2bguEiUgDA4/sddefault.jpg",
    description:
      "Powerful wisdom from Marcus Aurelius, Seneca and Epictetus",
  },
  {
    _id: "yH86jaBQ0F4",
    title: "A Lesson From Socrates That Will Change The Way You Think",
    creator: "Robot Banana",
    category:"Socrates",
    thumbnail:"https://img.youtube.com/vi/yH86jaBQ0F4/sddefault.jpg",
    description:
      "A classical Greek philosopher credited as one of the founders of Western philosophy, and as being the first moral philosopher, of the Western ethical tradition of thought.",
  },
  {
    _id: "Y4y2e4rUxfo",
    title: "9 Life Lessons From Socrates",
    creator: "The School of Life",
    category:"Socrates",
    thumbnail:"https://img.youtube.com/vi/Y4y2e4rUxfo/sddefault.jpg",
    description:
      "In this video we will be talking about 9 Life Lessons From Socrates. Socrates is sometimes considered as the founder of the Western philosophy and his work reflects the philosophy of Skepticism.",
  },
  {
    _id: "VDiyQub6vpw",
    title: "PHILOSOPHY - Plato",
    creator: "The School of Life",
    category:"Plato",
    thumbnail:"https://img.youtube.com/vi/VDiyQub6vpw/sddefault.jpg",
    description:
      "Plato was one of the world's earliest and possibly greatest philosophers. He matters because of his devotion to making humanity more fulfilled.",
  },
  {
    _id: "2S2nl8U8Vuk",
    title: "Friedrich Nietzsche - How To Achieve Self Mastery (Existentialism)",
    creator: "Philosophies for Life",
    category:"Friedrich Nietzsche",
    thumbnail:"https://img.youtube.com/vi/2S2nl8U8Vuk/sddefault.jpg",
    description:
      "In this video we bring you how to achieve self mastery from the philosophy of Friedrich Nietzsche. Friedrich Nietzsche believed that the fundamental drive of all living things is the so-called Will to Power, which is often seen as the impulse to overcome one’s environment, the impulse to grow, expand, and explore.",
  },
];
